import { jsonApi } from '@models/jsonApi';

jsonApi.define('domain-management/cdn-subdomain', {
  id: null,
  subdomain: '',
  is_validated: false,
});
